var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 7.875c-1.094.488-2.266.82-3.5.969 1.262-.75 2.231-1.938 2.688-3.356-1.18.7-2.488 1.2-3.875 1.475-1.12-1.188-2.713-1.938-4.475-1.938-3.387 0-6.137 2.75-6.137 6.137 0 .482.056.95.162 1.4-5.1-.256-9.625-2.7-12.65-6.413-.526.906-.831 1.962-.831 3.087 0 2.13 1.087 4.012 2.737 5.112-1.006-.031-1.956-.306-2.787-.762v.075c0 2.975 2.119 5.456 4.931 6.019-.515.14-1.056.216-1.619.216-.394 0-.78-.038-1.156-.113.781 2.438 3.05 4.213 5.738 4.263-2.1 1.65-4.75 2.631-7.625 2.631-.494 0-.981-.03-1.462-.087 2.719 1.744 5.95 2.762 9.413 2.762 11.294 0 17.475-9.356 17.475-17.475 0-.266-.006-.532-.018-.794 1.2-.863 2.244-1.944 3.068-3.175z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.efcf91e068e39b434cd18f1cfebed90d.svg";
export { ForwardRef as ReactComponent };